var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3998 7.74971H15.4998V5.94971C15.4998 3.46571 13.4838 1.44971 10.9998 1.44971C8.5158 1.44971 6.4998 3.46571 6.4998 5.94971V7.74971H5.5998C4.6098 7.74971 3.7998 8.55971 3.7998 9.54971V18.5497C3.7998 19.5397 4.6098 20.3497 5.5998 20.3497H16.3998C17.3898 20.3497 18.1998 19.5397 18.1998 18.5497V9.54971C18.1998 8.55971 17.3898 7.74971 16.3998 7.74971ZM10.9999 15.85C10.0099 15.85 9.19986 15.04 9.19986 14.05C9.19986 13.06 10.0099 12.25 10.9999 12.25C11.9899 12.25 12.7999 13.06 12.7999 14.05C12.7999 15.04 11.9899 15.85 10.9999 15.85ZM13.7898 7.75028H8.20981V5.95028C8.20981 4.41128 9.46081 3.16028 10.9998 3.16028C12.5388 3.16028 13.7898 4.41128 13.7898 5.95028V7.75028Z",
    fill: "#888281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.1f6bc2efbd629d59aa087977ed0002b3.svg";
export { ForwardRef as ReactComponent };